const ROOT_NODE = 'root-node';

export { ROOT_NODE };